import { MetadataContent } from '@jutro/legacy/uiconfig';
import { ServiceManager } from '@jutro/legacy/services';
import _ from 'lodash';
import metadata from './Preferences.metadata.json5';
import styles from './Preferences.module.scss';
import './Preferences.messages';

function Preferences() {
    const localeService = ServiceManager.getService('locale-service');
    
    const getAvailableLanguages = () => {
        const localeLanguages = localeService.getAvailableLanguages()

        return _.filter(localeLanguages, (localeLanguage) => localeLanguage !== 'en-US');
    }

    const overrideProps = {
        globalizationChooserField: {
            onLanguageValueChange: localeService.saveLanguage,
            languageValue: localeService.getStoredLanguage(),
            availableLanguageValues: getAvailableLanguages(),
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
}

export default Preferences;
